import { InputRoot } from './InputRoot'
import { InputLabel } from './InputLabel'
import { InputArea } from './InputArea'
import { InputSpan } from './InputSpan'
import { InputPasswordIcon } from './InputPasswordIcon'
import { InputSelect } from './Wrapper/InputSelect'
import { InputStandard } from './Wrapper/InputStandard'

export const Input = {
  Root: InputRoot,
  Area: InputArea,
  Label: InputLabel,
  Span: InputSpan,
  PasswordIcon: InputPasswordIcon,
  WrapperSelect: InputSelect,
  WrapperStandard: InputStandard,
}
